import React from "react";
import Navbar from "./Navbar";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import CoachingSection from "./CoachingSection";
import SpeakingSection from "./SpeakingSection";
import ServiceTestimonials from "./ServiceTestimonials";
import DualServiceCTA from "./DualServiceCTA";
import Footer from "./Footer";

/**
 * Main landing page component focused on coaching and speaking services
 */
const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      {/* Navigation */}
      <Navbar />

      {/* Hero Section with Contact Card */}
      <HeroSection />

      {/* About Section */}
      <AboutSection />

      {/* Coaching Section - Primary Service 1 */}
      <CoachingSection />

      {/* Speaking Section - Primary Service 2 */}
      <SpeakingSection />

      {/* Service-focused Testimonials */}
      <ServiceTestimonials />

      {/* Dual Service CTA */}
      <DualServiceCTA />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
